import React from "react";
import classNames from "classnames/bind";
import { useDispatch } from "react-redux";

import Select from "../SelectNew/Select";

import { useUpdateProjectMutation, addMessage } from "../../store/services";
import { posVersionTypes } from "../../constants";

import styles from "./POSSelect.module.scss";

import { EDataKeys, TData } from "../../types/TData";

const cx = classNames.bind(styles);

interface IPOSSelectProps {
  data: TData;
}



const POSSelect = ({ data }: IPOSSelectProps) => {
  const [updateProject] = useUpdateProjectMutation();
  const dispatch = useDispatch();

  // Parse API response and show appropriate message
  const handleUpdateResponse = (fieldName: string, response: any) => {
    if (response?.data && Array.isArray(response.data)) {
      const result = response.data[0];
      if (result?.status === 200) {
        dispatch(addMessage({ type: 'success', text: `${fieldName} updated successfully` }));
      } else if (result?.status === 400 && result?.errors) {
        const errorMessages = result.errors.map((err: any) => err.message).join(', ');
        dispatch(addMessage({ type: 'error', text: `Failed to update ${fieldName}: ${errorMessages}` }));
      }
    } else if (response?.error) {
      dispatch(addMessage({ type: 'error', text: `Failed to update ${fieldName}: Network error` }));
    }
  };

  // Handle field update with message feedback
  const handleFieldUpdate = (value: string) => {
    const updatePayload = [{ Id: data[EDataKeys.ID], [EDataKeys.POS_VERSION]: value || "" }];
    updateProject(updatePayload)
      .then((response) => {
        handleUpdateResponse("POS Version", response);
      })
      .catch((error) => {
        console.error('Failed to update POS Version:', error);
        dispatch(addMessage({ type: 'error', text: `Failed to update POS Version: Network error` }));
      });
  };

  // Convert posVersionTypes array to options format
  const posVersionOptions = posVersionTypes.map(version => ({
    value: version,
    label: version || "None"
  }));

  return (
    <div className={cx("pos-version")}>
      <div className={cx("select-box")}>
        <Select
          placeholder="Select POS Version"
          options={posVersionOptions}
          onChange={(value) => handleFieldUpdate(value as string)}
          value={data[EDataKeys.POS_VERSION] || ""}
          isClearable
        />
      </div>
    </div>
  );
};

export default POSSelect;
